<div class="mt-3">
  <div class="card position-relative">
    <div class="card-header bg-light">
      <h3 class="card-title">Documents</h3>
      @if (readonlyDocumentsPanel == false && !hideAddDocument && canUploadDocuments) {
        <div class="card-tools ms-auto me-1">
          <button class="btn btn-primary btn-sm" (click)="openAddFileDialog()">
            <i class="fa fa-solid fa-plus me-1"></i> Add document
          </button>
        </div>
      }
    </div>
    @if (files.length) {
      <div class="doc-status-bar py-3 px-3 border-bottom">
        <div class="d-flex align-items-center">
          <span class="me-2 text-secondary">Doc status:</span>
          @if (areAllDocsVerified) {
            <div class="d-flex align-items-center">
              <span class="text-muted">all documents verified</span>
              <div class="traffic-light ms-2">
                <span class="dot bg-success"></span>
              </div>
            </div>
          }
          @if (!areAllDocsVerified) {
            <div class="d-flex align-items-center">
              <span class="text-muted">not everything verified</span>
              <div class="traffic-light ms-2">
                <span class="dot bg-warning blink"></span>
                <span class="dot bg-warning blink" style="animation-delay: 0.75s"></span>
              </div>
            </div>
          }
        </div>
      </div>
    }
    <div class="card-body">
      @if (isLoading) {
        <loader [config]="loaderConfig"></loader>
      }

      @if (!files.length && !isLoading) {
        <div class="no-files-message">
          <p class="text-muted text-center">No documents attached.</p>
        </div>
      }

      @if (files.length && !isLoading) {
        <div class="table-responsive">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th class="text-center">FILE</th>
                <th class="text-center">DOWNLOAD</th>
                <th class="text-center">SENT</th>
                @if (canViewConfirmedColumn) {
                  <th class="text-center">CONFIRMED</th>
                }
              </tr>
            </thead>
            <tbody class="align-middle">
              @for (file of files; track file) {
                <tr>
                  <td>
                    <div class="d-flex align-items-center justify-content-start">
                      <i class="fa fa-file me-2 text-primary"></i>
                      <span>{{ file.customerDocument.name }}</span>
                    </div>
                  </td>
                  <td class="text-center">
                    @if (file.customerDocument.attachments && file.customerDocument.attachments.length > 0) {
                      <button class="btn btn-outline-secondary btn-sm"
                        (click)="downloadFile(file.customerDocument.attachments[0].url)"
                        title="Download file"
                        >
                        <i class="fa fa-solid fa-download"></i>
                      </button>
                    }
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center align-items-center">
                      @if (canUploadDocuments && (file.status === 'WAITING_FOR_CUSTOMER' || file.status === 'REJECTED')) {
                        <button
                          class="btn btn-outline-secondary btn-sm"
                          (click)="sendFile(file)"
                          title="Send">
                          <i class="fa fa-solid fa-paper-plane"></i>
                        </button>
                      }
                      @if (file.status === 'WAITING_FOR_OPERATOR' || file.status === 'ACCEPTED') {
                        <div class="d-flex justify-content-center align-items-center">
                          <span class="text-success me-2">
                            <i class="fa fa-solid fa-check"></i>
                          </span>
                          @if (file.customerAttachments && file.customerAttachments.length > 0) {
                            <button
                              class="btn btn-outline-secondary btn-sm"
                              (click)="downloadFile(file.customerAttachments[0].url)"
                              title="Download">
                              <i class="fa fa-solid fa-download"></i>
                            </button>
                          }
                        </div>
                      }
                      @if (file.status === 'REJECTED') {
                        <div class="d-flex justify-content-center align-items-center">
                          @if (file.customerAttachments && file.customerAttachments.length > 0) {
                            <button
                              class="btn btn-outline-secondary btn-sm ms-2"
                              (click)="downloadFile(file.customerAttachments[0].url)"
                              title="Download rejected file">
                              <i class="fa fa-solid fa-download"></i>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  @if (canViewConfirmedColumn) {
                    <td class="text-center">
                      @if (file.status === 'WAITING_FOR_OPERATOR') {
                        <div class="d-flex justify-content-center">
                          <button class="btn btn-outline-success btn-sm me-1"
                            (click)="updateFileStatus(file, 'ACCEPTED')"
                            title="Accept Document">
                            <i class="fa fa-solid fa-check"></i>
                          </button>
                          <button class="btn btn-outline-danger btn-sm"
                            (click)="updateFileStatus(file, 'REJECTED')"
                            title="Reject Document">
                            <i class="fa fa-solid fa-times"></i>
                          </button>
                        </div>
                      }
                      @if (file.status === 'ACCEPTED') {
                        <div class="d-flex justify-content-center">
                          <span class="text-success">
                            <i class="fa fa-solid fa-check"></i>
                          </span>
                        </div>
                      }
                      @if (file.status === 'REJECTED') {
                        <div class="d-flex justify-content-center">
                          <span class="text-danger">
                            <i class="fa fa-solid fa-times"></i>
                          </span>
                        </div>
                      }
                      @if (file.status === 'WAITING_FOR_CUSTOMER') {
                        <span>—</span>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    @if (canSendReminder) {
      <div class="card-footer">
        <div class="d-flex justify-content-center">
          <button class="btn btn-primary" (click)="sendReminder()" [disabled]="!hasFiles">
            Send reminder
          </button>
        </div>
      </div>
    }
  </div>

  <ng-template #addFileModalContent>
    <div class="modal-header">
      <h5 class="modal-title">Add document</h5>
      <button type="button" class="btn-close" (click)="closeAddFileDialog()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="form-group mb-3">
        <select-field
          [label]="'Select document to add:'"
          [options]="extraDocuments"
          [selectFormControl]="selectedExtraDocumentControl"
          (valueChange)="onExtraDocumentSelected($event)">
        </select-field>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="addDocument()" [disabled]="selectedExtraDocumentControl.invalid">Add</button>
      <button type="button" class="btn btn-secondary" (click)="closeAddFileDialog()">Cancel</button>
    </div>
  </ng-template>
</div>
